<template>
  <div class="suite-tabs" :class="{'no-link': shipCode==='OV'}">
    <ul>
      <li v-for="(item,index) in suiteOptions"
          :key="index" :class="{'is-selected':item.isSelected}"
          @click="handleSwitch(item)">{{item.title}}</li>
      <li v-if="shipCode!== 'OV'" class="suite-link" @click="onShowStateroomSuitePopup">礼遇详情</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "SuiteTabs",
  props: {
    showStateroomSuitePopup: {
      type: Function,
    },
    shipCode: {
      type: String,
      default: ""
    },
    suiteImage: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      imgUrl: process.env.VUE_APP_IMG_URL,
      suiteOptions: [{
        title: '全部',
        value: -1,
        isSelected: true
      },{
        title: '星际套房',
        value: 3,
        isSelected: false
      },{
        title: '天际套房',
        value: 2,
        isSelected: false
      },{
        title: '海际套房',
        value: 1,
        isSelected: false
      }]
    }
  },
  methods: {
    handleSwitch(row) {
      this.suiteOptions.forEach(r => r.isSelected=false);
      row.isSelected = true;
      this.$emit('switch', row);
    },
    onShowStateroomSuitePopup() {
      this.showStateroomSuitePopup(this.suiteImage);
    }
  }
}
</script>

<style lang="less" scoped>
.suite-tabs {
  position: relative;
  margin-bottom: 15px;
  &:before,
  &:after {
    content: "";
    height: 1px;
    width: 270px;
    position: absolute;
    top: 14px;
    background-color: #d2dadc;
  }
  &:before {
    left: 20px;
  }
  &:after {
    right: 20px;
  }
  & > ul {
    margin: 0 auto;
    width: 550px;
    & > li {
      cursor: pointer;
      display: inline-block;
      margin: 0 5px;
      width: 110px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      background-color: #FFFFFF;
      border: 1px solid #d2dadc;
      color: #2C77D2;
      &.is-selected {
        background-color: #F3BC00;
        border-color: #F3BC00;
        color: #FFFFFF;
      }
      &.suite-link {
        width: 70px;
        margin: 0;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background-color: transparent;
        border: 1px solid transparent;
        text-decoration: underline;
      }
    }
  }

  &.no-link {
    & > ul {
      width: 480px;
    }
    &:before,
    &:after {
      width: 300px;
    }
  }
}
</style>
